import * as React from "react";

function SvgStatistics({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M17 2.25A4.75 4.75 0 0121.75 7v10A4.75 4.75 0 0117 21.75H7A4.75 4.75 0 012.25 17V7A4.75 4.75 0 017 2.25zm0 1.5H7A3.25 3.25 0 003.75 7v10A3.25 3.25 0 007 20.25h10A3.25 3.25 0 0020.25 17V7A3.25 3.25 0 0017 3.75zM7 16.917a.75.75 0 01-.75-.75l.003-.05-.003-.057v-3.227c0-.826.632-1.504 1.439-1.577l.144-.006H9.5l.084.004V8.667c0-.826.632-1.504 1.439-1.577l.144-.006h1.667c.826 0 1.504.632 1.577 1.439l.006.144v.503l.083-.003h1.667c.826 0 1.504.632 1.577 1.439l.006.144v5.311l-.002.053.002.053a.75.75 0 01-.648.743l-.102.007H7zm2.5-4.167H7.833a.081.081 0 00-.076.05l-.007.033-.001 2.584h1.833l.001-2.583a.082.082 0 00-.05-.077L9.5 12.75zm3.334-4.166h-1.667a.081.081 0 00-.076.05l-.007.033v6.75h1.833v-6.75a.081.081 0 00-.05-.076l-.033-.007zm3.333 2.083H14.5a.081.081 0 00-.076.05l-.007.033v4.667h1.833V10.75a.081.081 0 00-.05-.076l-.033-.007z"
        />
      </g>
    </svg>
  );
}

export default SvgStatistics;
